<template>
  <section class="section-container d-flex justify-content-center align-items-center">
    <div class="card">
      <div class="main-container card-body">
        <div class="head-container text-center">
          <img src="../assets/logo.png" width="120" />
          <h4 class="m-t-15">Loading ...</h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {
    setTimeout(() => {
      if (this.checkDevice() === true) {
        window.location = '/login'
      } else {
        this.$router.push('/error').catch(() => {})
      }
    }, 1000)
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.section-container {
  width: 100wh !important;
  height: 100vh !important;
}
.main-container {
  width: 330px !important;
}
.head-container {
  margin: 0 !important;
  padding: 0 !important;
}
.info-container {
  margin: 0 !important;
  padding: 0 !important;
}
.note-container {
  margin: 0 !important;
  padding: 6px !important;
  border: 1px solid rgba(101, 109, 119, 0.16);
  border-radius: 5px;
  font-size: 12px;
  background: #fafbfd;
}
.credit-container {
  margin: 0 !important;
  padding: 0 !important;
}
.btn-secondary {
  background: #a1780f !important;
  border-color: #a1780f !important;
}
.text-10 {
  font-size: 10px !important;
}
.text-12 {
  font-size: 12px !important;
}
.text-mute {
  color: #727272 !important;
}
.m-t-5 {
  margin-top: 5px !important;
}
.m-t-10 {
  margin-top: 10px !important;
}
.m-t-15 {
  margin-top: 15px !important;
}
.m-t-20 {
  margin-top: 20px !important;
}
.m-b-5 {
  margin-bottom: 5px !important;
}
.m-b-10 {
  margin-bottom: 10px !important;
}
.m-b-15 {
  margin-bottom: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Loading.vue